import { Directive, Input, Optional, ElementRef, HostListener, Renderer } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[uiEnter]'
})
export class UiEnterDirective {

  @Input('uiEnter') id: string;

  constructor( @Optional() private model: NgModel,
    private evento: ElementRef, private renderer: Renderer) { }

  @HostListener('keypress', ['$event'])
  keypress(event) {
    if (event.which === 13) {
      document.getElementById(this.id).click();
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/resources/diretives/ui-enter.directive.ts